module.exports = __webpack_public_path__ + "static/media/file.2cfb6b8d.svg";